/* eslint no-useless-escape: 0 */
module.exports = {
  validations: {
    firstName: {
      type: 'string',
      min: 1,
      max: 20,
      required: true,
      regex: "^(?=[a-zA-ZÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ]+)[a-zA-Z0-9ÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ.\\- \\',]{0,19}((?! )[a-zA-Z0-9ÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ.\\- \\',])$",
    },
    lastName: {
      type: 'string',
      min: 1,
      max: 20,
      required: true,
      regex: "^(?=[a-zA-ZÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ]+)[a-zA-Z0-9ÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ.\\- \\',]{0,19}((?! )[a-zA-Z0-9ÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÂÁÈÊËÏÎÔœŒ.\\- \\',])$",
    },
    userName: {
      type: 'string',
      min: 6,
      max: 20,
      required: true,
      regex: '^[a-zA-Z0-9ÄÅäÖößÜüéùûÿàâåçèêëïîôzñáíóúãõÇÉÃÕÓÚÍÙÛŸÀÁÂÈÊËÏÎÔœŒ_.-]{6,20}$',
    },
    email: {
      type: 'string',
      required: true,
      // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
      max: 49,
    },
    password: {
      type: 'string',
      min: 8,
      max: 20,
      required: true,
      regex: '^(?=.*\\d+)(?=.*[a-zA-Z])[^<> ]{8,20}$',
    },
    postalCode: {
      required: true,
    },
    phoneNo: {
      type: 'string',
      min: 10,
      max: 20,
      regex: '^\\d{10,20}$',
      required: true,
    },
    addressLine1: {
      required: true,
      min: 3,
      max: 50,
    },
    addressLine2: {
      required: false,
      min: 0,
      max: 50,
    },
    city: {
      required: true,
      min: 1,
      max: 50,
    },
    state: {},
    ccNumber: {
      required: true,
    },
    ccExpDate: {
      required: true,
    },
    ccCVVNo: {
      show: true,
      required: true,
      min: 3,
      max: 4,
    },
    ibanNumber: {},
    bicNumber: {},
    couponCode: {},
    memberNo: {},
    jwt: {
      regex: '^[A-Za-z0-9-_=]+\\.[A-Za-z0-9-_=]+\\.?[A-Za-z0-9-_.+/=]*$',
    },
    uuid: {
      regex: '^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
    },
    birthDate: {
      regex: '(19|20)\\d\\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])',
    },
    timezone: {
      regex: '^[-+]([01]\\d|2[0-3]):([0-5]\\d)$',
    },
  },
};
